(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function revealSections(root = document) {
    if (reduced.matches || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('spirit-animate');
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { threshold: 0.08 });
    root.querySelectorAll('.spirit-reveal').forEach(el => observer.observe(el));
  }
  revealSections();
  document.addEventListener('shopify:section:load', e => revealSections(e.target));
  document.addEventListener('keydown', e => {
    if(e.key === 'Escape') document.querySelectorAll('.spirit-mobile-menu[open]').forEach(el => {el.open = false; el.querySelector('summary').focus();});
  });
  const storage = {
    get(key) { try { return localStorage.getItem(key); } catch { return null; } },
    set(key, val) { try { localStorage.setItem(key, val); } catch { /* Private browsing: offer still works. */ } }
  };
  function event(name) {
    if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish(name, { campaign: 'christmas-welcome' });
  }
  class SpiritScratch extends HTMLElement {
    connectedCallback() {
      if(this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog?.showModal) return;
      this.key = `spirit-gift-${this.dataset.version}`;
      this.canvas = this.querySelector('canvas');
      this.context = this.canvas.getContext('2d', { willReadFrequently: true });
      this.revealed = false;
      this.classList.add('spirit-gift-ready');
      this.querySelectorAll('[data-open-gift]').forEach(button => button.addEventListener('click', () => this.open()));
      this.querySelectorAll('[data-close-gift]').forEach(button => button.addEventListener('click', () => this.dialog.close()));
      this.querySelector('[data-reveal-gift]').addEventListener('click', () => this.reveal());
      this.dialog.addEventListener('click', e => { if(e.target === this.dialog) { const r=this.dialog.getBoundingClientRect(); if(e.clientX<r.left || e.clientX>r.right || e.clientY<r.top || e.clientY>r.bottom) this.dialog.close(); } });
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        if(this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
      });
      this.canvas.addEventListener('pointerdown', e => {
        if(this.revealed || !this.context) return;
        this.drawing = true; this.last = null; this.canvas.setPointerCapture(e.pointerId); this.scratch(e);
      });
      this.canvas.addEventListener('pointermove', e => {if(this.drawing) this.scratch(e);});
      const end = () => {this.drawing=false; this.last=null; this.checkProgress();};
      this.canvas.addEventListener('pointerup', end);
      this.canvas.addEventListener('pointercancel', end);
      const success = this.querySelector('[data-gift-success]');
      const errors = this.querySelector('[data-gift-errors]');
      if(success) { storage.set(this.key+'-subscribed', 'true'); this.reveal(false); this.open(); }
      else if(errors) { this.reveal(false); this.open(); }
      else if(this.dataset.home === 'true' && !window.Shopify?.designMode && !storage.get(this.key+'-subscribed')) {
        const last = Number(storage.get(this.key+'-seen')) || 0;
        if(Date.now() - last > Number(this.dataset.days)*86400000) this.timer = setTimeout(() => {
          const busy = document.querySelector('dialog[open], cart-drawer.active, details-modal details[open], .spirit-mobile-menu[open]');
          if(!busy && !document.hidden) this.open();
        }, Number(this.dataset.delay));
      }
    }
    disconnectedCallback() { clearTimeout(this.timer); if(this.dialog?.open) {this.dialog.close(); document.body.style.overflow=this.previousOverflow || '';} }
    open() {
      if(this.dialog.open) return;
      this.trigger = document.activeElement;
      this.previousOverflow = document.body.style.overflow;
      this.dialog.showModal();
      document.body.style.overflow='hidden';
      storage.set(this.key+'-seen', String(Date.now()));
      if(!this.revealed) this.paint();
      this.querySelector('[data-close-gift]').focus({preventScroll:true});
      event('spirit_offer_viewed');
    }
    paint() {
      if(!this.context) {this.reveal(false); return;}
      const ctx = this.context, w=this.canvas.width, h=this.canvas.height;
      ctx.globalCompositeOperation='source-over';
      const gradient=ctx.createLinearGradient(0,0,w,h);
      gradient.addColorStop(0,'#b89759');gradient.addColorStop(.45,'#edd3a2');gradient.addColorStop(1,'#b4975c');
      ctx.fillStyle=gradient;ctx.fillRect(0,0,w,h);
      ctx.strokeStyle='#fff5d059';ctx.lineWidth=1;
      for(let x=-h;x<w;x+=24){ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x+h,h);ctx.stroke();}
      ctx.fillStyle='#3c3926';ctx.textAlign='center';ctx.font='28px Georgia';ctx.fillText('✦  A little Christmas surprise  ✦',w/2,h/2-4);
      ctx.font='16px Arial';ctx.fillText('SCRATCH TO UNWRAP',w/2,h/2+37);
      ctx.globalCompositeOperation='destination-out';ctx.lineCap='round';ctx.lineJoin='round';ctx.lineWidth=48;
    }
    scratch(e) {
      const r=this.canvas.getBoundingClientRect();
      const p={x:(e.clientX-r.left)*this.canvas.width/r.width,y:(e.clientY-r.top)*this.canvas.height/r.height};
      const ctx=this.context;ctx.beginPath();ctx.moveTo(this.last?.x ?? p.x,this.last?.y ?? p.y);ctx.lineTo(p.x,p.y);ctx.stroke();
      ctx.beginPath();ctx.arc(p.x,p.y,24,0,Math.PI*2);ctx.fill();this.last=p;
      if(!this.lastCheck || performance.now()-this.lastCheck>180){this.lastCheck=performance.now();this.checkProgress();}
    }
    checkProgress() {
      if(this.revealed || !this.context) return;
      const data=this.context.getImageData(0,0,this.canvas.width,this.canvas.height).data;
      let clear=0,total=0;
      for(let i=3;i<data.length;i+=32){total++;if(data[i]<100)clear++;}
      if(clear/total>.34)this.reveal();
    }
    reveal(announce=true) {
      if(this.revealed)return;
      this.revealed=true;this.drawing=false;
      this.querySelector('.spirit-scratch-card').classList.add('is-revealed');
      this.querySelector('.spirit-gift-signup').hidden=false;
      this.querySelector('[data-reveal-gift]').hidden=true;
      this.canvas.setAttribute('aria-hidden','true');
      const description=this.querySelector('#SpiritGiftDescription');
      description.setAttribute('role','status');description.textContent='Your gift: 25% off your first order. Sign up below to receive your code.';
      if(announce)event('spirit_offer_revealed');
    }
  }
  if(!customElements.get('spirit-scratch')) customElements.define('spirit-scratch',SpiritScratch);
})();
